import useSetTabTitle from "hooks/useSetTabTitle";
import ExaminationList from "components/ExaminationList";
import { Stack } from "@mui/material";
import Header from "./components/Header";

const TestingList = () => {
  useSetTabTitle("Тестирования кандидатов");

  return (
    <Stack>
      <Header />
      <ExaminationList
        storageName='testing'
        defaultVisibleColumnList={[
          "numericId",
          "competencyMapTitle",
          "competencesCount",
          "candidateNumericId",
          "candidate",
          "createdAt",
          "status",
          "type",
        ]}
      />
    </Stack>
  );
};

export default TestingList;
